import { mutatorAction } from 'satcheljs';
import getExtensibilityState from '../store/getExtensibilityState';
import getAddinInstanceString from '../utils/getAddinInstanceString';

export default mutatorAction(
    'closeAllAutoRunCommandsforHostItemIndex',
    (hostItemIndex: string, targetWindow: Window) => {
        const autoRunAddinCommandWaitingQueue = getExtensibilityState()
            .autoRunAddinCommandWaitingQueue;
        const addinIdentifierString: string = getAddinInstanceString(targetWindow, hostItemIndex);
        autoRunAddinCommandWaitingQueue.delete(addinIdentifierString);
    }
);
